var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128.936,
    height: 100.406,
    viewBox: "0 0 128.936 100.406",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.471,
    y2: 1.092,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffca4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#ffdb93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3d36b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e57814"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(0 0.015)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(0 -0.103)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 70,
    height: 79,
    rx: 6,
    transform: "translate(30.759 16.495)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M6,23a6,6,0,0,1-6-6V13.667a6,6,0,0,1,6-6h8.315a6.406,6.406,0,1,1,12.556,0H35a6,6,0,0,1,6,6V17a6,6,0,0,1-6,6Z",
    transform: "translate(45.759 0.495)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(79.759 69.495)",
    fill: "#ff3133"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cancel",
    transform: "translate(87.893 77.635)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M143.095,129.189a.894.894,0,0,0-1.268,0l-5.685,5.685-5.685-5.685a.9.9,0,0,0-1.268,1.268l5.685,5.685-5.685,5.685a.9.9,0,0,0,.631,1.534.875.875,0,0,0,.631-.266l5.685-5.685,5.685,5.685a.9.9,0,0,0,.631.266.864.864,0,0,0,.631-.266.894.894,0,0,0,0-1.268l-5.671-5.685,5.685-5.685A.894.894,0,0,0,143.095,129.189Z",
    transform: "translate(-128.925 -128.925)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M6.485,13.389A7.39,7.39,0,0,0,.213,7.062a.248.248,0,0,1,0-.491l.078-.014.008,0,.071-.014.015,0,.067-.013.019,0,.064-.013.021,0L.619,6.49l.02,0,.051-.012.03-.007L.77,6.455.8,6.449l.055-.013L.88,6.428l.055-.014L.96,6.407l.05-.013.029-.008.047-.013.02-.006.06-.017.02-.006.062-.018.013,0L1.332,6.3h0A7.354,7.354,0,0,0,6.483.205.265.265,0,0,1,7,.205a7.345,7.345,0,0,0,5.046,6.058,9.219,9.219,0,0,0,1.242.3.248.248,0,0,1,0,.491,8.388,8.388,0,0,0-2.652.915,6.852,6.852,0,0,0-2.42,2.264h0A8.66,8.66,0,0,0,7,13.388a.259.259,0,0,1-.258.207H6.737A.262.262,0,0,1,6.485,13.389Z",
    transform: "translate(115.433 56.522)",
    fill: "#fbab4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    "data-name": "Union 3",
    d: "M6.485,13.389A7.39,7.39,0,0,0,.213,7.062a.248.248,0,0,1,0-.491l.078-.014.008,0,.071-.014.015,0,.067-.013.019,0,.064-.013.021,0L.619,6.49l.02,0,.051-.012.03-.007L.77,6.455.8,6.449l.055-.013L.88,6.428l.055-.014L.96,6.407l.05-.013.029-.008.047-.013.02-.006.06-.017.02-.006.062-.018.013,0L1.332,6.3h0A7.354,7.354,0,0,0,6.483.205.265.265,0,0,1,7,.205a7.345,7.345,0,0,0,5.046,6.058,9.219,9.219,0,0,0,1.242.3.248.248,0,0,1,0,.491,8.388,8.388,0,0,0-2.652.915,6.852,6.852,0,0,0-2.42,2.264h0A8.66,8.66,0,0,0,7,13.388a.259.259,0,0,1-.258.207H6.737A.262.262,0,0,1,6.485,13.389Z",
    transform: "translate(0 48.827)",
    fill: "#fbab4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_4",
    "data-name": "Union 4",
    d: "M6.485,13.389A7.39,7.39,0,0,0,.213,7.062a.248.248,0,0,1,0-.491l.078-.014.008,0,.071-.014.015,0,.067-.013.019,0,.064-.013.021,0L.619,6.49l.02,0,.051-.012.03-.007L.77,6.455.8,6.449l.055-.013L.88,6.428l.055-.014L.96,6.407l.05-.013.029-.008.047-.013.02-.006.06-.017.02-.006.062-.018.013,0L1.332,6.3h0A7.354,7.354,0,0,0,6.483.205.265.265,0,0,1,7,.205a7.345,7.345,0,0,0,5.046,6.058,9.219,9.219,0,0,0,1.242.3.248.248,0,0,1,0,.491,8.388,8.388,0,0,0-2.652.915,6.852,6.852,0,0,0-2.42,2.264h0A8.66,8.66,0,0,0,7,13.388a.259.259,0,0,1-.258.207H6.737A.262.262,0,0,1,6.485,13.389Z",
    transform: "translate(12.826 0.088)",
    fill: "#fbab4d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 38,
    height: 8,
    transform: "translate(39.759 41.495)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 23,
    height: 8,
    transform: "translate(39.759 64.495)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.b473a249ea54f51a9c84db45c0100d2b.svg";
export { ForwardRef as ReactComponent };